"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserGroupEventTypes = void 0;
var UserGroupEventTypes;
(function (UserGroupEventTypes) {
    UserGroupEventTypes["USER_ADDED_TO_GROUP"] = "AUTH/USER_ADDED_TO_GROUP";
    UserGroupEventTypes["USER_REMOVED_FROM_GROUP"] = "AUTH/USER_REMOVED_FROM_GROUP";
    UserGroupEventTypes["USER_GROUP_CREATED"] = "USER_GROUP/GROUP_CREATED";
    UserGroupEventTypes["USER_GROUP_MODIFIED"] = "USER_GROUP/GROUP_MODIFIED";
    UserGroupEventTypes["USER_GROUP_DELETED"] = "USER_GROUP/GROUP_DELETED";
    UserGroupEventTypes["USER_GROUP_PERMISSIONS_MODIFIED"] = "USER_GROUP/MODIFIED_PERMISSIONS";
    UserGroupEventTypes["USER_GROUP_ENABLED"] = "USER_GROUP/GROUP_ENABLED";
    UserGroupEventTypes["USER_GROUP_DISABLED"] = "USER_GROUP/GROUP_DISABLED";
    UserGroupEventTypes["USER_GROUP_RESTRICTED_PERMISSIONS_MODIFIED"] = "USER_GROUP/MODIFIED_RESTRICTED_PERMISSIONS";
})(UserGroupEventTypes || (exports.UserGroupEventTypes = UserGroupEventTypes = {}));
